import { FormControlLabel, Checkbox } from "@mui/material";
import React, { useState } from "react";

const initialValue = (state: any) => state.propertyUpdateAvailable;

export default function PropertyUpdateCheckComponent({ state, setState }: any) {
    const [isUpdateAvailable, updatePropertyAvailable] = useState(initialValue(state));

    const toggleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
        updatePropertyAvailable(event.target.checked);
        setState({
            ...state,
            propertyUpdateAvailable: event.target.checked,
        });
    };

    return (
        <>
            <FormControlLabel
                sx={{ ml: 2 }}
                control={<Checkbox checked={isUpdateAvailable} onChange={toggleCheckBox} />}
                label="Property Update Available"
            />
        </>
    );
}
